import React, { useState, useContext, useEffect } from 'react'
import UserContext from 'contexts/UserContext'
import Notifications from 'components/Notifications'
import Montant from './transfertContainer/montant'
import Synthese from '../components/Synthese'
import Benefiaire from './transfertContainer/beneficiare'
import PointCollecte from './transfertContainer/pointColect'
import Paiement from './transfertContainer/payment'
import { Partner} from 'types/Transfert'
import { Navigate, useNavigate } from 'react-router-dom'
import { useLocation, useParams } from 'react-router-dom'
import BeneficiaryContext from 'contexts/beneficiaryContext'
import StepTransfert from 'components/stepTransfert'
import { tracks } from 'requests/transfer'
import transferBeneficiaryContext from 'contexts/transferBeneficiaryContext'
import { updateBeneficiary } from 'requests/benificary'
import RechargeContext from 'contexts/rechargeContext'
import FlecheRetour from '../assets/arrow-back-navigation.svg'

function containsObject(name: string, list: any) {
  if (list.length > 0) {
    var i
    for (i = 0; i < list.length; i++) {
      if (list[i].name === name) {
        return true
      }
    }
  }
  return false
}
const DestinationCountry : Record<string, string>={
  'TUN': 'TND',
  'MAC': 'MAD',
  'SEN': 'XOF',
  
}

export default function DashboardTransfert() {
  const codeParams = useParams()?.code

  const codesValides = ['0', '1']
  const {  setRecharges } = useContext(RechargeContext)

  const [loading, setLoading] = useState(false)
  const [pathCode, setPathCode] = useState<string>()

  const [partnersData, setPartnersData] = useState<Partner[]>([])

  const { user } = useContext(UserContext)
  const { TransferData, setTransferData} = useContext(transferBeneficiaryContext)
  const {beneficiaries} = useContext(BeneficiaryContext)

  const [openalert, setOpenAlert] = useState<boolean>(false)

  const [valuePays, setValuePays] = useState<{value: string| undefined}>( 
    {value: DestinationCountry[user?.user?.destinationDefaultCountry || 'TUN']}
    // {value: user?.user.destinationDefaultCountry==='MAC'? 'MAD': user?.user.destinationDefaultCountry}
  )
 
  const [departureCurrencyId, setDepartureCurrencyId] = useState<string>('')
  const [destinationCurrencyId, setDestinationCurrencyId] = useState<string>('')

  const [euroValue, setEuroValue] = useState<number>(TransferData?.euroValue || 100)
  const [dinarValue, setDinarValue] = useState<number>(0)

  const [currencyToTND, setCurrencyToTND] = useState(0)
  const [com, setCom] = useState<number>(0)
  const [taux, setTaux] = useState<number>(0)

  //propsBeneficaire
  const [benificiareId, setBenificiareId] = useState<string>('')
  const [motif, setMotif] = useState<string>('')

  //propspoint de collecte
  const [colectPointId, setColectPointId] = useState<string>('')

  const nomstep = ['Montant', 'Bénéficiaire', 'Destination', 'Paiement']

  const [numStep, setNumStep] = useState(0)

  //propsPaiment
  const [idBeneficiary, setIdBeneficiary] = useState('')
  const [reseaux, setReseaux] = useState('')
  const [networkChecked, setNetworkChecked] = useState('')

  //carte bancaire value
  const [banqueName, setBanqueName] = useState('')
  const [iban, setIban] = useState('')

  const [selectedBnfList, setSelectedBnfList] = useState('')
  // const [choisirModePayment, setChoisirModePayment] = useState<number>(0)
  const [paymentMode, setPaymentMode] = useState( pathCode==='1' ? 'pi' : TransferData?.modeDePaiement || 'cb')

  const [bnfidentifiant, setBnfidentifiant] = useState('')
  const [bankcode, setBankcode] = useState('')
  const [swiftBic, setSwiftBic] = useState('')
  const [country, setCountry]= useState('')

  const [promoCode, setPromoCode] = useState('')

  const [trackId, setTrackId] = useState('')
  const navigation = useNavigate()

 const location=useLocation()
 const currenPath = location.pathname
  useEffect(() => {
    setPathCode(codeParams)
    setNumStep(0)
      setRecharges({})
      setReseaux('')
      if(pathCode==='1')
      {
        setTransferData({
            ...TransferData,
            modeDePaiement: 'pi',
            selectedOptionLien: 'Virement instantané'
        })
      }
      setTransferData({
            ...TransferData,
            operateurWallet: '',
        })
         
  }, [codeParams, pathCode])  
  
  const functionTracks = async (stepNumber: string) => {
    const id = user?.user?._id
    let dataTracks = {
      label: pathCode === '0' ? 'cash_transfer' : 'bank_transfer',
      step: stepNumber,
      userId: id,
    }

    if (stepNumber !== '0') {
      const newDataTracks = {
        ...dataTracks,
        trackId: trackId,
      }
      dataTracks = newDataTracks
      if(numStep > 2){
      const bankChanged = TransferData?.numBankBeneficiary !== beneficiaries?.numBankBeneficiary
      const cinChanged = TransferData?.cinBeneficiary !== beneficiaries?.cinBeneficiary

     
      // if (bankChanged || cinChanged) {
      if ((bankChanged || cinChanged) && pathCode==='1') {


        try{
            await updateBeneficiary (
                beneficiaries?.personalInfo.gender,
                beneficiaries?.personalInfo.phone.prefix,
                beneficiaries?.personalInfo.phone.number ,
                beneficiaries?.personalInfo.relationship,
                'FR',
                beneficiaries?.avatar,
      
                user?.user._id,
                beneficiaries?._id,
                beneficiaries?.personalInfo.firstName,
                beneficiaries?.personalInfo.lastName,
                TransferData?.banqueName,
                TransferData?.numBankBeneficiary,
                TransferData?.cinBeneficiary,
                swiftBic,
                bankcode,
              
                user?.token?.accessToken)

           }catch (err) {
          console.error('Erreur lors de la mise à jour du bénéficiaire :', err)
        }
      }
    }
  }
    try {
      const response = await tracks(dataTracks)
      if (response?.success === true) {
        setTrackId(response?.trackId)
      } else {
        console.error('response failed', response)
      }
      setLoading(true)
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    functionTracks('0')
  }, [])
  //redirection vers page 404
  if (codeParams && !codesValides.includes(codeParams)) {
  return <Navigate to="/404" replace />
}

  return (
  <div className="flex w-full  place-items-end mb-20 ">
    <div className="flex flex-col px-[140px] 3xl:px-[40px] lg:px-[10px] w-[70%] 3xl:w-[60%] items-center justify-center xl:w-full lg:mt-[40px] sm:mt-[20px]">

        <div className='w-full flex flex-col items-start'>

       
        <div className='flex w-full items-center'>
          <button
              type="button"
              onClick={() => navigation('/')}
              className="hidden lg:block cursor-pointer"
              aria-label="Retour à la page précédente"
            >
              <img src={FlecheRetour} alt="" />
            </button>          
            <h1  className='h1 w-full'>  Nouveau Transfert </h1>
        </div>

          <div className="flex justify-between w-full  ">
            {nomstep.map((item, index) => (
              <StepTransfert
                key={index}
                nomStep={item}
                numStep={index + 1}
                isActive={index <= numStep}
                lastStep={index < 3 ? true : false}
                isComplete={numStep > index}
                setNumStep={setNumStep}
              />
            ))}
          </div>
        </div>
       <div className='w-full'>
        {numStep === 0 && (
          <Montant
            euroValue={euroValue}
            setCounty={setCountry}
            setEuroValue={(value) => setEuroValue(value)}
            dinarValue={dinarValue}
            setDinarValue={(value) => setDinarValue(value)}
            setCurrencyToTND={(value) => setCurrencyToTND(value)}
            com={com}
            setCom={(value) => setCom(value)}
            taux={taux}
            setTaux={(value) => setTaux(value)}
            setDepartureCurrencyId={(value) => setDepartureCurrencyId(value)}
            setDestinationCurrencyId={(value) => setDestinationCurrencyId(value)}
            setNumStep={setNumStep}
            // setChoisirModePayment={(value) => setChoisirModePayment(value)}
            paymentMode={paymentMode}
            setPaymentMode={(value) => setPaymentMode(value)}
            promoCode={promoCode}
            setPromoCode={(value) => setPromoCode(value)}
            pathCode={pathCode}
            valuePays={valuePays}
            setValuePays={(value) => setValuePays(value)}
            functionTracks={functionTracks}
          />
        )}

        {numStep === 1 && (
          <Benefiaire
            paysCode={TransferData?.codeIso|| ''}
            setBenificiareId={(value) => setBenificiareId(value)}
            motif={motif}
            setMotif={(value) => setMotif(value)}
            setNumStep={setNumStep}
            setIdBeneficiary={(value) => setIdBeneficiary(value)}
            apiData={partnersData}
            idBeneficiary={idBeneficiary}
            setColectPointId={(value) => setColectPointId(value)}
            colectPointId={colectPointId}
            setSelectedBnfList={(value) => setSelectedBnfList(value)}
            selectedBnfList={selectedBnfList}
            valuePays={valuePays}
            functionTracks={functionTracks}
            pathCode={pathCode}
          />
        )}

        {numStep === 2 && (
          <PointCollecte
            setColectPointId={(value) => setColectPointId(value)}
            setNumStep={setNumStep}
            // idBeneficiary={idBeneficiary}
            // apiData={partnersData}
            colectPointId={colectPointId}
            // setChoisirCarte={(value) => setChoisirCarte(value)}
            // choisirCarte={pathCode}
            banqueName={banqueName}
            setBanqueName={(value) => setBanqueName(value)}
            iban={iban}
            setIban={(value) => setIban(value)}
            setSelectedOptionReseaux={(value) => setReseaux(value)}
            setSelectedBnfList={(value) => setSelectedBnfList(value)}
            selectedBnfList={selectedBnfList}
            bnfidentifiant={bnfidentifiant}
            setBnfidentifiant={(value) => setBnfidentifiant(value)}
            bankcode={bankcode}
            setBankcode={(value) => setBankcode(value)}
            swiftBic={swiftBic}
            setSwiftBic={(value) => setSwiftBic(value)}
            pathCode={pathCode}
            valuePays={valuePays}
            setNetworkChecked={(value) => setNetworkChecked(value)}
            euroValue={euroValue}
            functionTracks={functionTracks}
            selectedOptionReseaux={reseaux}
            country={country}
          />
        )}

        {numStep === 3 && (
          <Paiement
            departureCurrencyId={departureCurrencyId}
            destinationCurrencyId={destinationCurrencyId}
            amountD={euroValue}
            currencyToTND={dinarValue}
            com={com}
            totalSend={Number(euroValue) + Number(com)}
            benificiareId={benificiareId}
            motif={motif}
            colectPointId={colectPointId}
            senderId={user?.user?._id}
            token={user?.token?.accessToken}
            taux={taux}
            setOpenAlert={() => setOpenAlert(!openalert)}
            banqueName={banqueName}
            iban={iban}
            choisirCarte={pathCode}
            reseaux={reseaux}
            paymentMode={paymentMode}
            bankcode={bankcode}
            swiftBic={swiftBic}
            bnfidentifiant={bnfidentifiant}
            promoCode={promoCode}
            valuePays={valuePays}
            networkChecked={networkChecked}
            functionTracks={functionTracks}
          />
        )}
    </div>
    </div>
      <div className=" xl:hidden fixed bottom-0 mb-[100px] right-0 ">
        <Synthese
          text="Total à payer"
          LabelMantantToSend="Montant à envoyer"
          mantantToSend={euroValue}
          labelTaux="Taux de change"
          taux={taux}
          labelCom="Commission"
          com={com}
          LabelMantantToRecu="Montant à recevoir"
          // mantantToRecu={euroValue * com}
          mantantToRecu={dinarValue}

          valuePays={valuePays}
        />
      </div>
      {openalert && <Notifications type="succes" />}
    </div>
  )
}
